import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a451904"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "condition" }
const _hoisted_2 = { class: "left-field-block" }
const _hoisted_3 = {
  key: 0,
  class: "right-field-block"
}
const _hoisted_4 = {
  key: 1,
  class: "right-field-block"
}
const _hoisted_5 = { class: "operator-field" }
const _hoisted_6 = { class: "number-field" }
const _hoisted_7 = {
  key: 2,
  class: "right-field-block"
}
const _hoisted_8 = { class: "action-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormFieldComboBox = _resolveComponent("FormFieldComboBox")!
  const _component_FormField = _resolveComponent("FormField")!
  const _component_FormFieldMultiSelect = _resolveComponent("FormFieldMultiSelect")!
  const _component_FieldConditionTable = _resolveComponent("FieldConditionTable")!
  const _component_NorthIcon = _resolveComponent("NorthIcon")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_SouthIcon = _resolveComponent("SouthIcon")!
  const _component_DeleteIcon = _resolveComponent("DeleteIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditions, (condition, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "condition-block"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_FormFieldComboBox, {
              value: condition.type,
              "onUpdate:value": ($event: any) => ((condition.type) = $event),
              clearable: true,
              name: `type${index}`,
              label: "Тип условия",
              options: 
              condition.type && condition.type.value === 'BRAND'
                ? _ctx.typeConditionOptionList
                : _ctx.filteredTypeConditionOptionList
            
            }, null, 8, ["value", "onUpdate:value", "name", "options"])
          ]),
          (condition.type && condition.type.value === 'PRODUCT_TYPE')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_FormFieldComboBox, {
                  value: condition.productType,
                  "onUpdate:value": ($event: any) => ((condition.productType) = $event),
                  clearable: true,
                  name: `productType${index}`,
                  label: "Тип товара",
                  options: _ctx.productTypeOptionList
                }, null, 8, ["value", "onUpdate:value", "name", "options"])
              ]))
            : (condition.type && condition.type.value === 'PRICE')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_FormFieldComboBox, {
                      value: condition.operator,
                      "onUpdate:value": ($event: any) => ((condition.operator) = $event),
                      clearable: true,
                      name: `operator${index}`,
                      label: "Оператор",
                      options: _ctx.operatorOptionList
                    }, null, 8, ["value", "onUpdate:value", "name", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_FormField, {
                      value: condition.operand,
                      "onUpdate:value": ($event: any) => ((condition.operand) = $event),
                      type: "number",
                      name: `operand${index}`,
                      label: "Значение"
                    }, null, 8, ["value", "onUpdate:value", "name"])
                  ])
                ]))
              : (condition.type && condition.type.value === 'BRAND')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_FormFieldMultiSelect, {
                      "selected-options": condition.brands,
                      "onUpdate:selected-options": ($event: any) => ((condition.brands) = $event),
                      name: `brands${index}`,
                      label: "Производители",
                      options: _ctx.brandListOption
                    }, null, 8, ["selected-options", "onUpdate:selected-options", "name", "options"])
                  ]))
                : _createCommentVNode("", true),
          (
            condition.type &&
            condition.type.value === 'PRODUCT_TYPE' &&
            condition.productType
          )
            ? (_openBlock(), _createBlock(_component_FieldConditionTable, {
                key: 3,
                "product-type": condition.productType,
                "field-conditions": condition.fieldConditions
              }, null, 8, ["product-type", "field-conditions"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_BaseButton, {
            variant: "icon",
            title: "Move up",
            disabled: index === 0,
            onClick: ($event: any) => (_ctx.handleClick(_ctx.conditions, index, 'up'))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_NorthIcon)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"]),
          _createVNode(_component_BaseButton, {
            variant: "icon",
            title: "Move down",
            disabled: index === _ctx.conditions.length - 1,
            onClick: ($event: any) => (_ctx.handleClick(_ctx.conditions, index, 'down'))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SouthIcon)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"]),
          _createVNode(_component_BaseButton, {
            variant: "icon",
            title: "Delete",
            onClick: ($event: any) => (_ctx.removeField(index))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DeleteIcon)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]))
    }), 128))
  ]))
}